<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-light btn-sm btn-reg"> Cannibal edges </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/localSeo/reviews']"
        >
          Reviews
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Cluster</th>
              <th>Registry A</th>
              <th>Registry B</th>
              <th>Score</th>
              <th>Overlap</th>
              <th>Risk</th>
              <th class="th__status">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data">
              <td>{{ item.clusterId?.key || "N/A" }}</td>
              <td>{{ item.aRegistryId?.urlPath }}</td>
              <td>{{ item.bRegistryId?.urlPath }}</td>
              <td>{{ item.score }}</td>
              <td>{{ item.signals?.queryOverlap * 100 | number: "1.0-0" }}%</td>
              <td>{{ item.signals?.risk * 100 | number: "1.0-0" }}%</td>
              <td>
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
